// extracted by mini-css-extract-plugin
export default {"list":"articles-list_list__108Dc","card":"articles-list_card__2zPUi"};